'use strict';
/* created by lilei 2017.10.30
 *代替ng-disabled 按钮 被禁止 的 提示说明
 */
angular.module('util.btnDisabled', []).
directive('btnDisabled', ['$timeout', '$compile', function($timeout, $compile) {
    return {
        restrict: 'C',
        scope: {
            ngDisabled: '='
        },
        link: function(scope, iElement, attrs) {
            var $disabledTipDiv;
            scope.$watch('ngDisabled', function() {
                iElement.removeAttr('disabled');
            });
            $timeout(function() {
                init();
            }, 500);
            /**
             * [myClick description] 点击事件
             * @return {[type]} [description]
             */
            scope.myClick = function($event) {
                if (scope.ngDisabled) {
                    $event.stopPropagation();
                }
            };
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                var disabled = attrs.disabled;
                var disabledTip = attrs['disabledTip'] === undefined ? '请先选择稿件' : attrs['disabledTip'];
                if (scope.ngDisabled) {
                    var buttonHeight = iElement[0].offsetHeight;
                    var buttonWidth = iElement[0].offsetWidth;
                    var buttonTop = iElement.offset().top;
                    var buttonLeft = iElement.offset().left;
                    if (buttonHeight) {
                        var div = $compile('<div ng-click="myClick($event)" class="disabled"></div>')(scope);
                        iElement.append(div);
                        iElement.css({ "position": "relative" });
                        iElement.hover(function() {
                            if (!scope.ngDisabled) return;
                            if (attrs['disabledTip'] === "") return;
                            $(".tip_" + scope.$id).show();
                            iElement.css({ "cursor": "pointer", "position": "relative" });
                            $disabledTipDiv = $(".tip_" + scope.$id);
                            var selfHeight = $disabledTipDiv[0].offsetHeight;
                            var selfWidth = $disabledTipDiv[0].offsetWidth;
                            $disabledTipDiv.css({
                                top: buttonTop - selfHeight - 8,
                                left: buttonLeft + (buttonWidth - selfWidth) / 2
                            });
                        }, function() {
                            $(".tip_" + scope.$id).hide();
                        });
                        $('body').append(["<div class='disabled-tip tip_" + scope.$id + "'>" + disabledTip + "</div>"].join(""));
                    }
                }
            }
            var buttonClick;
            scope.$watch("ngDisabled", function(newV, oldV) {
                if (newV === true) {
                    iElement.addClass("disabled-true");
                } else {
                    iElement.removeClass("disabled-true");
                }
            });
            scope.$on("$destroy", function() {
                $(".tip_" + scope.$id).remove();
            });
        }
    };
}]);
